import {
  Button,
  DropdownMenuItem,
  DropdownMenuTrigger,
  Typography,
} from "@suraasa/placebo-ui"
import { useQueryClient } from "@tanstack/react-query"
import { Plus } from "iconoir-react"
import { useState } from "react"
import { Outlet } from "react-router-dom"

import { APIQueries } from "@/api/queries"
import PageContainer from "@/components/page-container"
import { useGlobalContext } from "@/context/global-context"
import ErrorPage from "@/features/error-page"
import ContentDropdownMenu from "@/features/home/component/new-content-dropdown/content-dropdown-menu"
import AddMultipleTeacherDialog from "@/features/home/manage-teacher-sheet/components/add-multiple-teacher-dialog"
import AddTeacher from "@/features/home/manage-teacher-sheet/components/add-teacher-dialog"
import { DialogEnum } from "@/features/home/manage-teacher-sheet/components/constant"
import { useClubId } from "@/lib/hooks/use-club-id"

import AddSchoolDialog from "../manage/add-school/dialog"
import Tabs from "./tabs"

const Dashboard = () => {
  const { organization } = useGlobalContext()

  const [openDialog, setOpenDialog] = useState<{
    type: DialogEnum
    data?: Record<string, any>
  } | null>(null)

  const onCloseDialog = () => setOpenDialog(null)

  const queryClient = useQueryClient()

  const orgId = useClubId()

  if (organization?.error) {
    return <ErrorPage />
  }

  return (
    <>
      <AddSchoolDialog
        open={openDialog?.type === DialogEnum.ADD_SCHOOL}
        handleClose={onCloseDialog}
      />

      <AddTeacher
        open={openDialog?.type === DialogEnum.ADD_A_TEACHER}
        onClose={onCloseDialog}
        onSubmit={() => {
          queryClient.invalidateQueries(
            APIQueries.teachers.organizationUserList({ orgId, params: {} }),
          )
        }}
      />
      <AddMultipleTeacherDialog
        open={openDialog?.type === DialogEnum.ADD_MULTIPLE_TEACHER}
        onClose={onCloseDialog}
        onSubmit={() => {
          queryClient.invalidateQueries(
            APIQueries.teachers.organizationUserList({ orgId, params: {} }),
          )
        }}
      />
      <div className="pb-10">
        <div className="mb-3 border-b border-surface-200 pt-3">
          <PageContainer>
            <div className="mb-4 flex flex-col justify-between gap-2 sm:flex-row sm:items-center">
              <Typography className="text-[32px] font-bold leading-[100%] tracking-tight">
                {organization?.data?.name}
              </Typography>
              <div className="flex flex-row items-center gap-1">
                <ContentDropdownMenu
                  triggerButtonSlot={
                    <DropdownMenuTrigger className="shrink-0" asChild>
                      <Button
                        color="black"
                        startAdornment={
                          <Plus className="!size-2" strokeWidth={2} />
                        }
                      >
                        Add Teacher(s)
                      </Button>
                    </DropdownMenuTrigger>
                  }
                >
                  <DropdownMenuItem
                    onClick={() => {
                      setOpenDialog({ type: DialogEnum.ADD_A_TEACHER })
                    }}
                  >
                    Add Teacher
                  </DropdownMenuItem>
                  <DropdownMenuItem
                    onClick={() => {
                      setOpenDialog({ type: DialogEnum.ADD_MULTIPLE_TEACHER })
                    }}
                  >
                    Import CSV
                  </DropdownMenuItem>
                </ContentDropdownMenu>
                <Button
                  onClick={() => {
                    setOpenDialog({ type: DialogEnum.ADD_SCHOOL })
                  }}
                  color={"black"}
                >
                  Add School
                </Button>
              </div>
            </div>
            <Tabs />
          </PageContainer>
        </div>

        <Outlet />
      </div>
    </>
  )
}

export default Dashboard
